export const profile = {
  name: "Sneha Sudhir",
  firstName: "Sneha",
  lastName: "Sudhir",
  initials: "SS",
  role: "Software Engineer",
  roles: [
    "Software Engineer",
    "UI/UX Designer",
    "Instructional Designer",
    "Graphic Designer",
  ],
  tagline:
    "From graphic design to instructional design and now software engineering — I blend development, UI/UX, graphic design and AI tools to build digital experiences that feel effortless.",
  location: "Bengaluru, India",
  email: "snehasudhir17@gmail.com",
  phone: "9994657112",
  resumeUrl: "#",

  socials: [
    { label: "LinkedIn", href: "https://www.linkedin.com/jobs/", icon: "linkedin" },
    { label: "GitHub", href: "https://github.com/SNEHA-SUDHIR", icon: "github" },
    { label: "Behance", href: "https://www.behance.net/snehasudhir", icon: "behance" },
  ],
} as const;

export const stats = [
  { value: 2, suffix: "+", label: "Years of experience" },
  { value: 3, suffix: "", label: "Design & code disciplines" },
  { value: 16, suffix: "+", label: "Tools & technologies" },
  { value: 2, suffix: "", label: "Featured projects" },
] as const;

export type SkillGroup = {
  title: string;
  icon: string;
  blurb: string;
  skills: { name: string; level: number }[];
};

export const skillGroups: SkillGroup[] = [
  {
    title: "Software Engineering",
    icon: "code",
    blurb: "Building reliable, scalable software",
    skills: [
      { name: "Python", level: 85 },
      { name: "React.js", level: 88 },
      { name: "Web Development", level: 90 },
      { name: "APIs", level: 82 },
      { name: "SQL", level: 80 },
    ],
  },
  {
    title: "Tools & AI",
    icon: "sparkles",
    blurb: "Modern tooling and AI-powered workflows",
    skills: [
      { name: "Linux", level: 78 },
      { name: "Git/GitHub", level: 88 },
      { name: "AI Tools", level: 90 },
      { name: "DeepSeek", level: 85 },
      { name: "Pi", level: 84 },
      { name: "OpenCode", level: 82 },
    ],
  },
  {
    title: "Design",
    icon: "palette",
    blurb: "Crafting clean, human-centered interfaces",
    skills: [
      { name: "UI/UX Design", level: 92 },
      { name: "Graphic Design", level: 88 },
      { name: "Figma", level: 90 },
      { name: "Icon Design", level: 85 },
      { name: "Visual Design", level: 86 },
    ],
  },
];

export const marquee = [
  "React",
  "Python",
  "Linux",
  "Figma",
  "UI/UX Design",
  "Graphic Design",
  "AI Tools",
  "Web Development",
  "SQL",
  "Git/GitHub",
  "DeepSeek",
  "Icon Design",
];

export type Project = {
  index: string;
  title: string;
  category: string;
  description: string;
  tags: string[];
  accent: string;
  link: string;
};

export const projects: Project[] = [
  {
    index: "01",
    title: "Tejas Networks — Icon Design",
    category: "Icon Design",
    description:
      "Created professional icons and visual assets for Tejas Networks, focusing on networking and telecom-related concepts with a clean and consistent corporate design style.",
    tags: ["Figma", "Icon Design", "Visual Design"],
    accent: "#22d3ee",
    link: "#",
  },
  {
    index: "02",
    title: "Learning Management System",
    category: "UI/UX Design",
    description:
      "Designed a modern and user-friendly UI for a Learning Management System, focusing on clean navigation, usability, responsive design and a good learning experience.",
    tags: ["Figma", "UI/UX", "Responsive Design"],
    accent: "#8b5cf6",
    link: "#",
  },
];

export type Experience = {
  period: string;
  role: string;
  company: string;
  summary: string;
  points: string[];
};

export const experience: Experience[] = [
  {
    period: "6-Month Internship",
    role: "Graphic Designer",
    company: "Graphic Version",
    summary:
      "My journey began in graphic design — crafting visual identities and brand assets with a designer's eye for detail.",
    points: [
      "Created visual assets, icons and brand materials",
      "Built a strong foundation in typography, color and layout",
      "Developed a clean, consistent design style",
    ],
  },
  {
    period: "1.5 Years",
    role: "Instructional Designer",
    company: "Tejas Networks",
    summary:
      "Moved into instructional design, turning complex technical concepts into clear, engaging learning experiences.",
    points: [
      "Designed instructional content and visual learning materials",
      "Simplified networking and telecom concepts through design",
      "Bridged the gap between design thinking and technology",
    ],
  },
  {
    period: "Current",
    role: "Software Engineer",
    company: "Tejas Networks",
    summary:
      "Now engineering software — combining development, UI/UX design and AI tools to ship real products.",
    points: [
      "Developing web applications with modern tools",
      "Applying UI/UX and graphic design to engineering work",
      "Using AI tools to accelerate development workflows",
    ],
  },
];
